import styled from 'styled-components';

import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const VariantSelectorSection = styled.section`
    padding-top: ${getPurpurSpacing('300')};
    margin-bottom: ${getPurpurSpacing('600')};
    border-top: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray200')};
`;

export const BadgeBlockTitle = styled.div`
    display: flex;
    align-items: center;
    margin-top: 0;
    border-top: 1px solid ${getPurpurColor('gray200')};
    padding-top: ${getPurpurSpacing('600')};
    font-weight: bold;
    font-size: 1rem;
    line-height: 1.25;
    margin-bottom: ${getPurpurSpacing('300')};
    gap: ${getPurpurSpacing('200')};

    &:first-child {
        padding-top: ${getPurpurSpacing('300')};
        border-top: none;
    }

    & ~ & {
        margin-top: ${getPurpurSpacing('600')};
    }
`;

export const BadgeBlockOutOfStockLabel = styled.mark`
    background-color: unset;
    color: ${getPurpurColor('red600')};
    font-size: 0.875rem;
    font-weight: normal;
`;

export const BadgeBlockContainer = styled.div.attrs({ role: 'radiogroup' })`
    display: flex;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('150')};
    margin-bottom: ${getPurpurSpacing('200')};
`;
